module.exports = __webpack_public_path__ + "static/banner-aereo-b6df0d3ed2ab63a1539b57fbc51660da.jpg";